import { render, staticRenderFns } from "./HomeBonuses.vue?vue&type=template&id=4b00845d&"
import script from "./HomeBonuses.vue?vue&type=script&lang=js&"
export * from "./HomeBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports